import { ICar } from "src/api/car";

export const quantitySort = (a: ICar, b: ICar) => {
  if (typeof b.carsQuantity === "number" && a.carsQuantity === null) return -1;
  if (typeof a.carsQuantity === "number" && b.carsQuantity === null) return 1;
  if (a.carsQuantity === null && b.carsQuantity === null) return 0;
  if (a.carsQuantity !== null && b.carsQuantity !== null) {
    if (a.carsQuantity < b.carsQuantity) return -1;
    if (a.carsQuantity > b.carsQuantity) return 1;
    if (a.carsQuantity === b.carsQuantity) return 0;
  }
  return 0;
};
